<template>
    <modal name="judge-info-modal" class="judge-info-modal"
           :width="650"
           :height="'auto'"
           @before-open="handlerBeforeOpen"
           @before-close="handlerBeforeClose"
    >
        <div class="modal_title">심사정보</div>
        <div class="pl30 pr30 pb30">
            <div class="judge_info_content" v-if="hasData()">
                <div v-for="(judge,index) in entryData" :key="`judge-master-${index}`" class="ji_content_box">
                    <div><span class="judge_title">심사자 : </span>
                        <span class="hover" @click="movePage(judge.mb_no)">{{judge.mb_nick}}</span></div>
                    <div><span class="judge_title">배점 : </span>{{judge.cij_score}}점</div>
                    <div><span class="judge_title">배점이유 : </span>{{judge.cij_reason}}</div>
                </div>
            </div>
            <div class="judge_info_content"  v-else>
                심사정보가 없습니다.
            </div>
            <div class="btn_box text-center mt20">
                <el-button class="reg_btn_out" @click="closeModal()">학인</el-button>
            </div>
        </div>
    </modal>
</template>

<script>
import util from "@/mixins/util";

export default {
    name: "JudgeInfoModal",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            entryData: []
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        handlerBeforeOpen(event) {
            let idx = event.params.ci_idx
            if(!util.isEmpty(idx)){
                this.getEntryDetail(idx)
            }
        },
        handlerBeforeClose() {
            this.$router.replace(this.$route.path);
        },
        closeModal() {
            this.$modal.hide('judge-info-modal')
        },
        movePage(mb_no) {
            this.closeModal()
            this.$router.push(`/member/${mb_no}`)
        },
        getEntryDetail(ci_idx) {
            let params = {
                cid: ci_idx
            }
            this.$api.$competition.getEntryDetail(params).then(res => res.Data.Result).then(res => {
                if (res.Info.type == 1) {
                    this.entryData = res.List
                } else {

                }
            })
        },
        hasData(){
            return !util.isEmpty(this.entryData)
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
